import React from "react";

const Nosotros = React.lazy(() => import("../components/pages/nosotros"));
const Servicios = React.lazy(() => import("../components/pages/servicios"));
const Contacto = React.lazy(() => import("../components/pages/contacto"));

const routes = [
    { path: 'nosotros', element: Nosotros },
    { path: 'servicios', element: Servicios },
    { path: 'contacto', element: Contacto },
]

export default routes